



































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import storage from 'baimahu/storage';
import { MUTATION_LOG_ON_OUT } from '@/store/type';
const { VUE_APP_FCAPI: FCAPI, VUE_APP_EXPIRED: EXPIRED, VUE_APP_API } = process.env;
const md5 = require('blueimp-md5');
const API = {
  login_merchant: `${FCAPI}/shang/ruan/passport/merchant`,
  checkQyLogin: `${VUE_APP_API}/qy/passport/login/login-by-session`,
};
@Component
export default class SelectMerchant extends Vue {
  @Mutation(MUTATION_LOG_ON_OUT) logOnOut: any;
  isLoading: boolean = false;
  mobile: any = -1;
  merchant_list: any = [];
  logOut() {
    this.logOnOut(false);
    this.$router.push('/login-mendian');
  }
  async selectMerchant(item: any) {
    const res = await this.$axios.post(API.login_merchant, {
      mobile: storage.getItem('account_info').mobile,
      password: storage.getItem('account_info').password,
      merchant_id: item.merchant_id,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    item.activated_module = item.merchant.activated_module;
    item.package_type = 2;
    storage.setItem('profile', item, EXPIRED);
    await this.$axios.get(`${API.checkQyLogin}`);
    this.logOnOut(true);
    this.$router.push(`/`);
  }
  created() {
    this.mobile = this.$route.query.mobile;
    this.merchant_list = storage.getItem('merchant_list');
  }
}
